/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Header.scss';
import Link from '../Link';
import Navigation from '../Navigation';
import logoUrl from './logo.svg';

class Header extends React.Component {
  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <Link className={s.brand} to="/">
            <img
              src={logoUrl}
              width="129"
              height="143"
              alt="Water is a Human Right"
            />
          </Link>
          <Navigation />
          <nav className={s.social}>
            <a
              className={s.social__link}
              href="https://twitter.com/right2water"
            >
              <svg width="18" height="15" viewBox="0 0 18 15">
                <path
                  fill="#445F7C"
                  fillRule="evenodd"
                  d="M28.0803571,13.4107143 C27.5818427,14.1398846 26.9791702,14.7611581 26.2723214,15.2745536 C26.2797619,15.3787208 26.2834821,15.5349692 26.2834821,15.7433036 C26.2834821,16.7105703 26.1421145,17.6759624 25.859375,18.6395089 C25.5766355,19.6030554 25.1469523,20.5275253 24.5703125,21.4129464 C23.9936727,22.2983675 23.3072956,23.0814698 22.5111607,23.7622768 C21.7150258,24.4430838 20.755214,24.9862331 19.6316964,25.3917411 C18.5081789,25.7972491 17.306554,26 16.0267857,26 C14.0104066,26 12.1651869,25.4605709 10.4910714,24.3816964 C10.7514894,24.4114585 11.0416651,24.4263393 11.3616071,24.4263393 C13.0357227,24.4263393 14.5275232,23.9129516 15.8370536,22.8861607 C15.0557997,22.8712797 14.3564019,22.6313267 13.7388393,22.1662946 C13.1212767,21.7012626 12.6971738,21.1078905 12.4665179,20.3861607 C12.7120548,20.4233633 12.9389871,20.4419643 13.1473214,20.4419643 C13.4672635,20.4419643 13.7834806,20.4010421 14.0959821,20.3191964 C13.2626446,20.1480646 12.5725474,19.7332622 12.0256696,19.0747768 C11.4787919,18.4162914 11.2053571,17.6517901 11.2053571,16.78125 L11.2053571,16.7366071 C11.7113121,17.0193467 12.2544614,17.1718749 12.8348214,17.1941964 C12.3437475,16.8668138 11.9531265,16.4389907 11.6629464,15.9107143 C11.3727664,15.3824378 11.2276786,14.8095269 11.2276786,14.1919643 C11.2276786,13.5371991 11.3913674,12.9308064 11.71875,12.3727679 C12.6190521,13.4814044 13.7146513,14.3686723 15.0055804,15.0345982 C16.2965094,15.7005242 17.6785641,16.0706842 19.1517857,16.1450893 C19.0922616,15.8623498 19.0625,15.5870549 19.0625,15.3191964 C19.0625,14.3221676 19.414059,13.4721017 20.1171875,12.7689732 C20.820316,12.0658447 21.6703819,11.7142857 22.6674107,11.7142857 C23.7090826,11.7142857 24.58705,12.0937462 25.3013393,12.8526786 C26.1123552,12.6964278 26.8749964,12.4062521 27.5892857,11.9821429 C27.3139867,12.8378019 26.7857182,13.4999977 26.0044643,13.96875 C26.696432,13.8943449 27.3883894,13.7083348 28.0803571,13.4107143 Z"
                  transform="translate(-10 -11)"
                />
              </svg>
            </a>
            <a
              className={s.social__link}
              href="https://www.facebook.com/right2water-259222457451652/"
            >
              <svg width="18" height="18" viewBox="0 0 18 18">
                <path
                  fill="#445F7C"
                  fillRule="evenodd"
                  d="M67.9285714,10.2857143 C68.8139925,10.2857143 69.5710534,10.6000713 70.1997768,11.2287946 C70.8285002,11.857518 71.1428571,12.6145789 71.1428571,13.5 L71.1428571,24.2142857 C71.1428571,25.0997068 70.8285002,25.8567677 70.1997768,26.4854911 C69.5710534,27.1142145 68.8139925,27.4285714 67.9285714,27.4285714 L65.8303571,27.4285714 L65.8303571,20.7879464 L68.0513393,20.7879464 L68.3861607,18.1986607 L65.8303571,18.1986607 L65.8303571,16.546875 C65.8303571,16.1302063 65.9177819,15.8177094 66.0926339,15.609375 C66.267486,15.4010406 66.6078844,15.296875 67.1138393,15.296875 L68.4754464,15.2857143 L68.4754464,12.9754464 C68.0066941,12.9084818 67.3444983,12.875 66.4888393,12.875 C65.4769295,12.875 64.6677858,13.1726161 64.0613839,13.7678571 C63.4549821,14.3630982 63.1517857,15.2038636 63.1517857,16.2901786 L63.1517857,18.1986607 L60.9196429,18.1986607 L60.9196429,20.7879464 L63.1517857,20.7879464 L63.1517857,27.4285714 L57.2142857,27.4285714 C56.3288646,27.4285714 55.5718037,27.1142145 54.9430804,26.4854911 C54.314357,25.8567677 54,25.0997068 54,24.2142857 L54,13.5 C54,12.6145789 54.314357,11.857518 54.9430804,11.2287946 C55.5718037,10.6000713 56.3288646,10.2857143 57.2142857,10.2857143 L67.9285714,10.2857143 Z"
                  transform="translate(-54 -10)"
                />
              </svg>
            </a>
          </nav>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Header);
